import { useTemporaryMessagesState } from './useTemporaryMessagesState';

export const useIsTemporaryMessageDisplayed = (): boolean => {
    const { isMessageDisplayed } = useTemporaryMessagesState();

    return isMessageDisplayed;
};
